module.exports = __webpack_public_path__ + "img/img_03.9cd65a22.jpg";